import { DriverDashboardGrid, DriverStatusResponseDTO, DriverIsOutOfServiceRequestDto, DriverResponseDTO, DriversRequestDTO, DriverDashboardResponseDTO, DriverDashboardGridCarrier, CheckingAccountMovementsPageResponseDTO, CreditDebitNoteRequestDTO, DriverCheckingAccountMovementsResponseDTO, DriverComboDto, DriverGrid, DriverIsActiveRequestDto, DriverLastPlaceResponseDTO, DriverRegistrationResponseDTO, DriverRequestDTO, TotalDriversResponseDTO, DriverListRequestDTO } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AddDriverCommand, IAddDriver,IAddDriverCommandParameters } from './command/addDriver.command';
import { GetDriverCommand, IGetDriversCommandParameters } from './command/getDrivers.command';
import { GetDriversByVehicleCommand, IGetDriversByVehiclesCommandParameters } from './command/getDriversByVehicle.command';
import { GetDriverByIdCommand, IGetDriverByIdCommandParameters } from './command/getDriverById.command';
import { IdentityService } from '../authentication/identity.service';
import { FindDriversByContainsName, IFindDriversByContainsNameCommandParameters } from './command/findDriversByContainsLastName.command';
import { MultiRegionService } from '../multiregion/multiregion.service';
import { IUpdateDriverCommandParameters, UpdateDriverCommand } from './command/updateDriver.command';
import { SortEnum } from '../enum/sortEnum.enum';
import { GetDriverLastPlaceCommand, IGetDriverLastPlaceCommandParameters } from 'app/services/driver/command/getDriverLastPlace.command';
import { IUpdateDriverIsActiveCommand, IUpdateDriverIsActiveCommandParameters, UpdateDriverIsActiveCommand } from './command/updateDriverIsActive.command';
import { GetTotalDriversCommand, IGetTotalDriversCommandParameters } from './command/getTotalDrivers.command';
import { GetDriversListCommand, IGetDriversListCommandParameters } from './command/getDriversList.command';
import { DriverPlaceResponse } from '../models/responses/driver-last-place.response';
import { GetDriverLocationCommand } from './command/get-driver-location.command';
import { GetDriversCheckingAccountMovementsCommand } from './command/getDriversCheckingAccountMovements.command';
import { AddCheckingAccountMovementCommand, MovementForEnum } from './command/addCheckingAccountMovement.command';
import { TranslateService } from '@ngx-translate/core';
import { DriverResendInviteCommand, IDriverResendInviteParameters } from './command/driverResendInvite.command';
import { UpdateDriverVehicleCommand, IUpdateDriverVehicleCommandParameters } from './command/updateDriverVehicle.command';
import { ConnectionServices } from '../authentication/connection/connection.service';
//import { NotificationsService } from '../utilities/notifications.service';
import { ErrorsEnum } from '../enum/errors.enum';
import { ICommandResponse } from '../authentication/connection/iCommandResponse';
import { GetAllDriverCommand, IGetAllDriversCommandParameters } from "./command/getAllDrivers.command";
import { IUpdateDriverParameters, UpdateDriverOnlineStatusCommand } from './command/updateDriverStatusOnline';
import { GetDriverInfoByIdCommand, IGetDriverInfoByIdCommandParameters } from './command/getDriverInfoById.command';
import { GetDriversByCarrierForComboCommand } from './command/getDriversByCarrierForCombo.command';
import { GetOwnerDriverCommand, IGetOwnerDriversCommandParameters } from './command/getOwnerDrivers.command';
import { GetTotalOwnerDriversCommand, IGetTotalOwnerDriversCommandParameters } from './command/getTotalOwnerDrivers.command';
import { GetOwnerDriverLastPlaceCommand, IGetOwnerDriverLastPlaceCommandParameters } from './command/getOwnerDriverLastPlace.command';
import { IUpdateDriverIsOutOfServiceCommand, IUpdateDriverIsOutOfServiceCommandParameters, UpdateDriverIsOutOfServiceCommand } from './command/updateDriverIsOutOfService.command';
import { GetDriverBasicInfoCommand, IGetDriverBasicInfoCommandParameters } from './command/getDriverBasicInfo.command';
import { GetDriverStateCommand, IGetDriverStateCommandParameters } from './command/getDriverStatusCommand';
import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';
import { SessionService } from '../session/session.service';
import { IUpdateDriversNodoInRTDBParameters, updateDriversNodoInRTDBCommand } from './command/updateDriversNodoInRTDBCommand';
import { AlertService } from '../components/alerts/alert.service';


@Injectable()
export class DriverService {
  private titleMessage: string;
  constructor(
    private _connectionService: ConnectionServices,
    //private _notificationsService: NotificationsService,
    private _identityService: IdentityService,
    private _multiRegionService: MultiRegionService,
    private _translateService: TranslateService,
    private _sessionService: SessionService,
    private _alertService: AlertService,
  ) {
    this.titleMessage = 'toast.driver.title';
  }

  public createDriver(driver: DriverRequestDTO): Observable<boolean | IAddDriver> {
    const driverCommand = new AddDriverCommand();
    driverCommand.setParameters({
      cuil: driver.cuil,
      dni: driver.dni,
      driverImage: driver.driverImage,
      driverImageMax: driver.driverImageMax,
      bornDate: driver.bornDate,
      carrierUserId: parseInt(this._identityService.userId),
      firstName: driver.firstName,
      lastName: driver.lastName,
      genre: driver.genre,
      age: driver.age,
      tributeIdentification: driver.tributeIdentification,
      city: driver.city,
      languages: driver.languages,
      driverUserEmail: driver.driverUserEmail,
      streetName: driver.streetName,
      streetNumber: driver.streetNumber,
      typeOfLivingPlace: driver.typeOfLivingPlace,
      floorNumber: driver.floorNumber,
      province: driver.province,
      postalCode: driver.postalCode,
      country: driver.country,
      driverSchedule: driver.driverSchedule,
      phoneNumber: driver.phoneNumber,
      travelPercentage: driver.travelPercentage,
      paymentSettings: driver.paymentSettings,
      vehicles: driver.vehicles,
      documents: driver.documents,
      existsUser: driver.existsUser,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.shared.message.successful_message_add'
          );
          */
          return true;
        }),
        catchError((error) => {
          let message = 'toast.users.message.error_while_finding_email';
          if(error.status == 409){
            if(error.error.errorCode == "MAIL_UNIQUE"){
              console.log("MAIL_UNIQUE");
              message = 'toast.users.message.error_mail_unique';
            }else if(error.error.errorCode == "USER_ALREADY_EXIST"){
              console.log("USER_ALREADY_EXIST");
              message = 'toast.users.message.error_user_already_exist';
            }
          }
          this._alertService.alertWarning(
            this._translateService.instant('toast.users.message.attention'),
            this._translateService.instant(message),
            false
          );
          if (error.status === 409) {
            if (
              [
                'DOCUMENT_NOT_FOUND',
                'DOCUMENT_FIELD_NOT_FOUND',
                'DOCUMENT_FIELD_VALUE_UNIQUE',
                'INVALID_EXPIRATION_DATE',
              ].includes(error.error.errorCode)
            ) {
              if (error.error.errorCode === 'DOCUMENT_FIELD_VALUE_UNIQUE') {
                let document: string = error.error.description.split('|')[0];
                let field: string = error.error.description.split('|')[1];
                let document_field: string =
                  this._translateService.instant(
                    'carrier.documentation.types.' + document
                  ) +
                  ' - ' +
                  this._translateService.instant(
                    'carrier.documentation.field_types.' + field
                  );
                let errorDesc: string = this._translateService.instant(
                  'carrier.documentation.server_errors.document_field_value_unique'
                );
                this._alertService.alertWarning(
                  this._translateService.instant('carrier.vehicles.title'),
                  document_field + ': ' + errorDesc,
                  false
                );
              } else {
                this._alertService.alertWarning(
                  this._translateService.instant('carrier.vehicles.title'),
                  this._translateService.instant('carrier.documentation.server_errors.' +
                    error.error.errorCode.toLowerCase()),
                  false
                );
              }
            } else {
              this._alertService.alertWarning(
                this._translateService.instant(this.titleMessage),
                this._translateService.instant('toast.driver.error_code.' +
                  error.error.errorCode.toLowerCase()),
                false
              );
            }
          } else {
            this._alertService.alertWarning(
              this._translateService.instant(this.titleMessage),
              error,
              false
            );
          }
          return throwError(error.error);
        })
      )
  }

  public updateDriver(
    driver: DriverRequestDTO,
    id: number,
    existsUser: string
  ): Observable<boolean> {
    const driverCommand = new UpdateDriverCommand();
    driverCommand.setParameters(<IUpdateDriverCommandParameters>{
      idDriver: id,
      carrierUserId: driver.carrierUserId,
      firstName: driver.firstName,
      lastName: driver.lastName,
      dni: driver.dni,
      genre: driver.genre,
      age: driver.age,
      tributeIdentification: driver.tributeIdentification,
      city: driver.city,
      languages: driver.languages,
      cuil: driver.cuil,
      driverImage: driver.driverImage,
      driverImageMax: driver.driverImageMax,
      driverImageSmall: driver.driverImageSmall,
      bornDate: driver.bornDate,
      driverUserEmail: driver.driverUserEmail,
      streetName: driver.streetName,
      streetNumber: driver.streetNumber,
      typeOfLivingPlace: driver.typeOfLivingPlace,
      floorNumber: driver.floorNumber,
      province: driver.province,
      postalCode: driver.postalCode,
      country: driver.country,
      driverSchedule: driver.driverSchedule,
      phoneNumber: driver.phoneNumber,
      travelPercentage: driver.travelPercentage,
      paymentSettings: driver.paymentSettings,
      vehicles: driver.vehicles,
      documents: driver.documents,
      existsUser: existsUser,
      vehicleId: driver.vehicleId
    });

    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.shared.message.successful_message_modify'
          );
          */
          return true;
        }),
        catchError((error) => {
          /*
          if (error.status === 409) {
            if (
              [
                'DOCUMENT_NOT_FOUND',
                'DOCUMENT_FIELD_NOT_FOUND',
                'DOCUMENT_FIELD_VALUE_UNIQUE',
                'INVALID_EXPIRATION_DATE',
              ].includes(error.error.errorCode)
            ) {
              if (error.error.errorCode === 'DOCUMENT_FIELD_VALUE_UNIQUE') {
                let document: string = error.error.description.split('|')[0];
                let field: string = error.error.description.split('|')[1];
                let document_field: string =
                  this._translateService.instant(
                    'carrier.documentation.types.' + document
                  ) +
                  ' - ' +
                  this._translateService.instant(
                    'carrier.documentation.field_types.' + field
                  );
                let errorDesc: string = this._translateService.instant(
                  'carrier.documentation.server_errors.document_field_value_unique'
                );
                this._notificationsService.showInternalErrorMessage(
                  'carrier.vehicles.title',
                  document_field + ': ' + errorDesc
                );
              } else {
                this._notificationsService.showInternalErrorMessage(
                  'carrier.vehicles.title',
                  'carrier.documentation.server_errors.' +
                    error.error.errorCode.toLowerCase()
                );
              }
            } else {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.'+ error.error.errorCode.toLowerCase()
              );
            }
          } else if (error.status === 400) {
            this._notificationsService.showInternalErrorMessage(
              this.titleMessage,
              error.error.description
            );
          } else {
            this._notificationsService.showHttpErrorMessage(
              this.titleMessage,
              error
            );
          }
            */
          return throwError(error.error);
        })
      )
  }

  public getDrivers(
    carrier: string,
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    termToSearch: string,
    states: string,
    operability: boolean,
    find?: string,
    dashboard: boolean = false,
    driverId?: string
  ): Observable<DriverGrid> {
    const driverCommand = new GetDriverCommand(dashboard);
    driverCommand.setParameters(<IGetDriversCommandParameters>{
      carrierUserId: carrier,
      column: column,
      page: page,
      size: size,
      sort: sort,
      termToSearch: termToSearch,
      states: states,
      find: find,
      operability: operability != null ? operability : '',
      findDriverId: driverId,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data as DriverGrid;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getDriversDashboard(
    carrier: string,
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    termToSearch: string,
    state: string,
    value?: string,
    dashboard:boolean = false,
    driverId?: string,
    vehicleIdSwitch: boolean = false
  ): Observable<any> {
    const driverCommand = new GetDriverCommand(dashboard);
    driverCommand.setParameters(<IGetDriversCommandParameters>{
      carrierUserId: carrier,
      column: column,
      page: page,
      size: size,
      sort: sort,
      termToSearch: termToSearch,
      states: state,
      value: value,
      findDriverId: driverId,
      vehicleIdSwitch: vehicleIdSwitch,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data as DriverGrid;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getOwnerDriversDashboard(
    carrier: string,
    ownerId: string,
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    termToSearch: string,
    state: string,
    operability: boolean,
    value?: string,
    dashboard = false,
    driverId?: string,
    vehicleIdSwitch: boolean = false
  ): Observable<DriverDashboardGrid> {
    const driverCommand = new GetOwnerDriverCommand(dashboard);
    driverCommand.setParameters(<IGetOwnerDriversCommandParameters>{
      carrierUserId: carrier,
      ownerId: ownerId,
      column: column,
      page: page,
      size: size,
      sort: sort,
      termToSearch: termToSearch,
      state: state,
      find: value,
      operability: operability != null ? operability : '',
      findDriverId: driverId,
      vehicleIdSwitch: vehicleIdSwitch,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          return response as any;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  getDriverInfoDashboard(carrierUserId: any, driverId: any) {
    const command = new GetDriverInfoByIdCommand();
    command.setParameters(<IGetDriverInfoByIdCommandParameters>{
      carrierUserId: carrierUserId,
      driverId: driverId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getAllDrivers(carrier: string): Observable<DriverGrid> {
    const driverCommand = new GetAllDriverCommand();
    driverCommand.setParameters(<IGetAllDriversCommandParameters>{
      carrierUserId: carrier,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data as DriverGrid;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getDriversByVehicle(
    carrier: string,
    vehicleId: number
  ): Observable<DriverRegistrationResponseDTO> {
    const driverCommand = new GetDriversByVehicleCommand();
    driverCommand.setParameters(<IGetDriversByVehiclesCommandParameters>{
      carrierEmail: carrier,
      vehicle: vehicleId,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }
  public getDriverById(
    idDriver: number
  ): Observable<DriverRegistrationResponseDTO> {
    const driverCommand = new GetDriverByIdCommand();
    driverCommand.setParameters(<IGetDriverByIdCommandParameters>{
      idDriver: idDriver,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data as DriverRegistrationResponseDTO;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }
  public getDriverByContainsLastName(
    term: string
  ): Observable<DriverComboDto[]> {
    const driverCommand = new FindDriversByContainsName();
    driverCommand.setParameters(<IFindDriversByContainsNameCommandParameters>{
      terms: term,
      carrierId: this._identityService.userId,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((data) => {
          const response = data as DriverComboDto[];
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getDriverLastPlace(
    state: string
  ): Observable<Array<DriverLastPlaceResponseDTO>> {
    const driverCommand = new GetDriverLastPlaceCommand();
    driverCommand.setParameters(<IGetDriverLastPlaceCommandParameters>{
      carrierUserId: this._identityService.userId,
      state: state,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getOwnerDriverLastPlace(
    state: string
  ): Observable<Array<DriverLastPlaceResponseDTO>> {
    const driverCommand = new GetOwnerDriverLastPlaceCommand();
    driverCommand.setParameters(<IGetOwnerDriverLastPlaceCommandParameters>{
      carrierUserId: this._identityService.userId,
      ownerId: this._identityService.passengerId.toString(),
      state: state,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public updateDriverIsActive(
    driverIsActive: DriverIsActiveRequestDto
  ): Observable<IUpdateDriverIsActiveCommand> {
    const driverCommand = new UpdateDriverIsActiveCommand();
    driverCommand.setParameters(<IUpdateDriverIsActiveCommandParameters>{
      driverUserId: driverIsActive.driverUserId,
      enabled: driverIsActive.enabled,
      carrierUserId: driverIsActive.carrierUserId,
    });

    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.driver.message.updated'
          );
          */
          return response;
        }),
        catchError((error) => {
          /*
          if (error.error != null && error.error.errorCode != null) {
            if (error.error.errorCode === ErrorsEnum.DRIVER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.selected_not_found'
              );
            } else if (error.error.errorCode === ErrorsEnum.CARRIER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.carrier.error_code.carrier_selected_not_found'
              );
            } else {
              this._notificationsService.showHttpErrorMessage(
                this.titleMessage,
                error
              );
            }
          }
            */
          return throwError(false);
        })
      )
  }

  public updateDriverIsOutOfService(
    driverIsOutOfService: DriverIsOutOfServiceRequestDto
  ): Observable<IUpdateDriverIsOutOfServiceCommand> {
    const driverCommand = new UpdateDriverIsOutOfServiceCommand();
    driverCommand.setParameters(<IUpdateDriverIsOutOfServiceCommandParameters>{
      driverUserId: driverIsOutOfService.driverUserId,
      enabled: driverIsOutOfService.enabled,
      carrierUserId: driverIsOutOfService.carrierUserId
    });

    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(response => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.driver.message.updated'
          );
          */
          return response;
        }),
        catchError(error => {
          /*
          if (error.error != null && error.error.errorCode != null) {
            if (error.error.errorCode === ErrorsEnum.DRIVER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.selected_not_found'
              );
            } else if (error.error.errorCode === ErrorsEnum.CARRIER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.carrier.error_code.carrier_selected_not_found'
              );
            } else {
              this._notificationsService.showHttpErrorMessage(
                this.titleMessage,
                error
              );
            }
          */
          return throwError(false);
        })
      )
  }

  public updateDriverOnlineStatus(
    driverNumber: number
  ) {
    const command = new UpdateDriverOnlineStatusCommand();
    command.setParameters(<IUpdateDriverParameters>{
      driverUserId: driverNumber,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.driver.message.driver_status_success'
          );
          */
          return response;
        }),
        catchError((error) => {
          /*
          if (error.error != null && error.error.errorCode != null) {
            if (error.error.errorCode === ErrorsEnum.DRIVER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.selected_not_found'
              );
            } else if (
              error.error.errorCode === ErrorsEnum.DRIVERS_NOT_AVAILABLE
            ) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.is_not_available'
              );
            } else if (error.error.errorCode === ErrorsEnum.DRIVER_IN_TRAVEL) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.already_in_travel'
              );
            } else {
              this._notificationsService.showHttpErrorMessage(
                this.titleMessage,
                error
              );
            }
          }
            */
          return throwError(false);
        })
      )
  }

  public updateDriverVehicle(
    driverId: number,
    carrierUserId: string,
    vehicleId: number
  ): Observable<ICommandResponse> {
    const driverCommand = new UpdateDriverVehicleCommand();
    driverCommand.setParameters(<IUpdateDriverVehicleCommandParameters>{
      driverUserId: driverId,
      vehicleId: vehicleId,
      carrierUserId: carrierUserId,
    });

    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            this.titleMessage,
            'toast.driver.message.updated'
          );
          */
          return response;
        }),
        catchError((error) => {
          /*
          if (error.error != null && error.error.errorCode != null) {
            if (error.error.errorCode === ErrorsEnum.DRIVER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.driver.error_code.selected_not_found'
              );
            } else if (error.error.errorCode === ErrorsEnum.CARRIER_NOT_FOUND) {
              this._notificationsService.showInternalErrorMessage(
                this.titleMessage,
                'toast.carrier.error_code.carrier_selected_not_found'
              );
            } else {
              this._notificationsService.showHttpErrorMessage(
                this.titleMessage,
                error
              );
            }
          }
            */
          return throwError(false);
        })
      )
  }

  getTotalDrivers(
    carrier: string,
    driverId?: string
  ): Observable<TotalDriversResponseDTO> {
    const totalDriverCommand = new GetTotalDriversCommand();
    totalDriverCommand.setParameters(<IGetTotalDriversCommandParameters>{
      carrierUserId: carrier,
      driverId: driverId,
    });
    return this._connectionService
      .Request(totalDriverCommand)
      .pipe(
        map((data) => {
          const response = data as TotalDriversResponseDTO;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  getTotalOwnerDrivers(
    carrier: string,
    ownerId: string,
    driverId?: string
  ): Observable<TotalDriversResponseDTO> {
    const totalDriverCommand = new GetTotalOwnerDriversCommand();
    totalDriverCommand.setParameters(<IGetTotalOwnerDriversCommandParameters>{
      carrierUserId: carrier,
      ownerId: ownerId,
      driverId: driverId,
    });
    return this._connectionService
      .Request(totalDriverCommand)
      .pipe(
        map((data) => {
          const response = data as TotalDriversResponseDTO;
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  getDriversList(driverName: string): Observable<DriverListRequestDTO[]> {
    const driverListCommand = new GetDriversListCommand();
    driverListCommand.setParameters(<IGetDriversListCommandParameters>{
      carrierUserId: this._identityService.userId,
      driverName: driverName,
    });
    return this._connectionService
      .Request(driverListCommand)
      .pipe(
        map((response) => {
          return response as DriverListRequestDTO[];
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getDriverLocation(
    driverUserId: number
  ): Observable<DriverPlaceResponse> {
    const driverPlaceCommand = new GetDriverLocationCommand();
    driverPlaceCommand.setDriverId(driverUserId);

    return this._connectionService
      .Request(driverPlaceCommand)
      .pipe(
        map((response) => {
          return response as DriverPlaceResponse;
        }),
        catchError((error) => {
          return throwError(false);
        })
      )
  }

  public getDriverCheckingAccountMovements(driverId: number,
                                           page?: number,
                                           size?: number,
                                           column?: string,
                                           sort?: SortEnum,
                                           startDate?: Date,
                                           endDate?: Date,
                                           movementType?: string): Observable<DriverCheckingAccountMovementsResponseDTO> {
    const driversCheckingAccountMovementsCommand = new GetDriversCheckingAccountMovementsCommand();
    driversCheckingAccountMovementsCommand.setParameters({
      driverId: driverId,
      carrierUserId: this._identityService.userId,
      page: page,
      size: size,
      column: column,
      sort: sort,
      startDate: startDate,
      endDate: endDate,
      movementType: movementType
    });

    return this._connectionService
      .Request(driversCheckingAccountMovementsCommand)
      .pipe(
        map((response) => {
          return response as DriverCheckingAccountMovementsResponseDTO;
        }),
        catchError((error) => {
          return throwError(false);
        })
      )
  }
  public saveCheckingAccountMovement(
    driverId: number,
    note: CreditDebitNoteRequestDTO
  ): Observable<void> {
    const addCheckingAccountMovementCommand =
      new AddCheckingAccountMovementCommand();
    addCheckingAccountMovementCommand.setParameters({
      carrierUserId: Number(this._identityService.userId),
      id: driverId,
      movementFor: MovementForEnum.DRIVER,
      noteType: note.noteType,
      amount: note.amount,
      reason: note.reason,
      subUserId: this._sessionService.getItem(StorageKeyEnum.subUserId)
    });

    return this._connectionService
      .Request(addCheckingAccountMovementCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.checking_accounts.movement',
            'toast.checking_accounts.message.movement_success'
          );
          */
          return;
        }),
        catchError((error) => {
          return throwError(false);
        })
      )
  }
  public resendSolicitude(driverId: number): Observable<boolean> {
    const resendCommand = new DriverResendInviteCommand();
    const params: IDriverResendInviteParameters = {
      driverId: driverId,
    };
    resendCommand.setParameters(params);
    return this._connectionService
      .Request(resendCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.driver.title',
            'toast.driver.message.resend_email_success'
          );
          */
          return true;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.driver.title',
            'toast.driver.error_code.resend_email_error'
          );
          */
          return throwError(false);
        })
      )
  }

  public findDriversByCarrierForCombo(
    carrier: string
  ): Observable<DriverListRequestDTO[]> {
    const driverCommand = new GetDriversByCarrierForComboCommand();
    driverCommand.setParameters(<IGetAllDriversCommandParameters>{
      carrierUserId: carrier,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map((response) => {
          return response as any;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  public getDriverBasicInfo(
    idDriver: number
  ): Observable<DriverRegistrationResponseDTO> {
    const driverCommand = new GetDriverBasicInfoCommand();
    driverCommand.setParameters(<IGetDriverBasicInfoCommandParameters>{
      driverId: idDriver
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(data => {
          const response = data as DriverRegistrationResponseDTO;
          return response;
        }),
        catchError(error => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
    }

  public getDriverState(
    carrier: string,
    driverId:string
  ):Observable<DriverStatusResponseDTO>{
    const command= new GetDriverStateCommand();
    command.setParameters(<IGetDriverStateCommandParameters>{
      carrierUserId: carrier,
      driverId:driverId
    })
    return this._connectionService
      .Request(command)
      .pipe(
        map(data =>{
          const response = data as DriverStatusResponseDTO
          return response;
        }),
        catchError(error => {
          /*
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          */
          return throwError(false);
        })
      )
  }

  updateDriversNodoRTDB(driverId: string, nodo: string) {
    const command = new updateDriversNodoInRTDBCommand();
    command.setParameters(<IUpdateDriversNodoInRTDBParameters>{
      carrierId: this._identityService.userId,
      driverId: driverId,
      nodo: nodo
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          */
          return throwError(false);
        })
      )
  }
}
